export default __webpack_public_path__ + "resources/eap-info.pdf";